import React, { useRef, useState } from 'react';
import { Recorder } from "react-voice-recorder";
import 'react-voice-recorder/dist/index.css';
import { ToastNotification } from 'components/shared';
import './style.scss';

export const VoiceRecorder = (props) => {

    const [audioDetails, setAudioDetails] = useState({
        url: null,
        blob: null,
        chunks: null,
        duration: {
            h: 0,
            m: 0,
            s: 0
        }
    });
    const toastRef = useRef(null);

    const onAudioStop = (data) => {
        setAudioDetails(data);
    }

    const onAudioUpload = (file) => {
        if (file) {
            file.lastModifiedDate = new Date();
            file.name = `voice.mp3`;
            props.callbackFileUpload(file);
        } else {
            toastRef.current?.showToast({ type: "error", title: "Error", message: "No voice has been recorded!" });
        }
    }

    const onAudioReset = () => {
        setAudioDetails({
            url: null,
            blob: null,
            chunks: null,
            duration: {
                h: 0,
                m: 0,
                s: 0
            }
        });
    }


    return (
        <>
            <Recorder
                record={true}
                title={"Voice clip"}
                audioURL={audioDetails.url}
                showUIAudio
                handleAudioStop={onAudioStop}
                handleReset={onAudioReset}
                handleAudioUpload={onAudioUpload}
                mimeTypeToUseWhenRecording={`audio/webm`}
            />

            <ToastNotification ref={toastRef} />
        </>

    );
}